import { call, put, select } from "redux-saga/effects";
import { getQuestionForPractice } from "../actions/questionActionsHelper";
import { setLoading } from "../reducers/questionReducersHelper";
import { selectedSection$ } from "../selectors/questionSelectors";
import * as questionApi from '../../api/index';

export function* handleGetQuestionForPractice(action) {
    try {
        yield put(setLoading(true));
        const selectedSection = yield select(selectedSection$);
        const section = selectedSection || action.payload?.section;
        const userId = action.payload?.userId;
        const response = yield call(questionApi.getQuestionForPractice, section, userId, {
            recordId: action.payload?.recordId,
            currentQuestionId: action.payload?.currentQuestionId,
        });
        yield put(getQuestionForPractice.success(response?.data));
    } catch (err) {
        yield put(getQuestionForPractice.failed(err.response?.data?.error || err.message || 'Failed to fetch practice question.'));
    } finally {
        yield put(setLoading(false));
    }
}
